export default "__VITE_PUBLIC_ASSET__72092522__"